import {
  Stethoscope,
  Sparkles,
  Sun,
  Activity,
  Layers,
  Scissors,
  Crown,
  Waypoints,
  Anchor,
  Smile,
  AlignCenter,
  Baby,
  Wand2,
  Siren,
} from "lucide-react";

const SERVICES = [
  {
    icon: Stethoscope,
    title: "General Dentistry",
    desc: "Comprehensive exams, diagnosis, and routine care for the whole family.",
  },
  {
    icon: Sparkles,
    title: "Dental Cleaning",
    desc: "Professional scaling & polishing to keep gums and teeth healthy.",
  },
  {
    icon: Sun,
    title: "Teeth Whitening",
    desc: "Safe, in-office whitening for a brighter, confident smile.",
  },
  {
    icon: Activity,
    title: "Root Canal Treatment",
    desc: "Painless RCT with modern rotary systems to save your natural teeth.",
  },
  {
    icon: Layers,
    title: "Dental Fillings",
    desc: "Tooth-colored composite fillings that look and feel natural.",
  },
  {
    icon: Scissors,
    title: "Tooth Extraction",
    desc: "Gentle extractions with local anesthesia and minimal discomfort.",
  },
  {
    icon: Crown,
    title: "Dental Crowns",
    desc: "Durable ceramic and zirconia crowns to restore damaged teeth.",
  },
  {
    icon: Waypoints,
    title: "Dental Bridges",
    desc: "Fixed prosthetic bridges to replace missing teeth beautifully.",
  },
  {
    icon: Anchor,
    title: "Dental Implants",
    desc: "Long-lasting titanium implants for a permanent, natural feel.",
  },
  {
    icon: Smile,
    title: "Dentures",
    desc: "Comfortable partial and complete dentures customized for you.",
  },
  {
    icon: AlignCenter,
    title: "Braces",
    desc: "Metal, ceramic and clear aligners for perfectly straight smiles.",
  },
  {
    icon: Baby,
    title: "Kids Dentistry",
    desc: "Friendly, gentle care designed to keep young smiles happy.",
  },
  {
    icon: Wand2,
    title: "Cosmetic Dentistry",
    desc: "Veneers, contouring, and smile design tailored to your face.",
  },
  {
    icon: Siren,
    title: "Emergency Dental Care",
    desc: "Same-day relief for pain, swelling, or dental trauma.",
  },
];

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-20 sm:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl reveal">
          <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[#4FC3F7]/15 text-[#0288d1] text-xs font-semibold tracking-wide uppercase">
            Our Services
          </div>
          <h2 className="mt-5 text-4xl sm:text-5xl font-semibold tracking-tight text-[#1F2937] leading-[1.05]">
            Complete dental solutions{" "}
            <span className="text-[#009688]">under one roof</span>.
          </h2>
          <p className="mt-5 text-lg text-[#1F2937]/65">
            From routine check-ups to advanced cosmetic and surgical
            procedures — we cover every dental need with precision and care.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-5">
          {SERVICES.map(({ icon: Icon, title, desc }, i) => (
            <article
              key={title}
              data-testid={`service-card-${i}`}
              className="reveal group relative bg-white rounded-2xl border border-[#009688]/10 p-5 sm:p-6 hover:border-[#009688]/40 hover:-translate-y-1 transition-all duration-300 shadow-[0_4px_20px_rgb(0,0,0,0.02)] hover:shadow-[0_20px_40px_rgba(0,150,136,0.12)]"
              style={{ transitionDelay: `${(i % 4) * 40}ms` }}
            >
              <div className="w-12 h-12 rounded-2xl bg-[#009688]/8 grid place-items-center mb-4 group-hover:bg-[#009688] transition-colors duration-300">
                <Icon
                  className="w-6 h-6 text-[#009688] group-hover:text-white transition-colors duration-300"
                  strokeWidth={1.8}
                />
              </div>
              <h3 className="font-[Outfit] font-semibold text-[17px] text-[#1F2937]">
                {title}
              </h3>
              <p className="mt-1.5 text-[13.5px] text-[#1F2937]/60 leading-relaxed">
                {desc}
              </p>
              <div className="absolute inset-x-6 -bottom-px h-px bg-gradient-to-r from-transparent via-[#009688]/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
